export default __webpack_public_path__ + "static/media/1.271ad384.png";